// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"YRxzziMWOF","tooltip":"_1q7pPuQitk","hidden":"_3aH3J0ZC2X","tooltipContainer":"eDqOyb2lab"};